import { gql } from "@apollo/client";
const LOCATIONS = gql`
  query locations {
    locations {
      __typename
      ... on Location {
        id
        postal_code
        name
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { LOCATIONS };
